
const { location } = require('window');

const _ = require('lodash');

const { localStorage } = require('js-storage')
	  .initNamespaceStorage('page-my-common/prolongation-notification');

const server = require('server');
const config = require('config');

const { profile } = require('myrgs-auth-helpers');

const page = require('page-common');

const PolicyForProlongation = require('page-my-common/js/policy-for-prolongation.js');
// eslint-disable-next-line max-len
const notificationTemplate = require('page-my-common/templates/notifications/policy-for-prolongation.html');


module.exports = function () {

	function onNotificationAcknowledged (QuotationCaseID) {
		localStorage.set('notificationAcknowledged.QuotationCase' + QuotationCaseID, true);
	}

	profile.updateAtLeastOnce()
		.then(() => {
			if (profile.hasRole('PhysicalInsurantPerson')) {
				return server.my.api.lk.getQuotationsForProlongation();
			}
			return { responseJSON: { Data: [] } };
		})
		.then(({ responseJSON: { Data } }) => {
			if (!Data.length) {
				return null;
			}

			return config.cms.pageUrls.get()
				.then((pageUrls) => {
					return {
						config: {
							cms: {
								pageUrls,
							},
						},
					};
				})
				.then((options) => {
					const policies = [];

					_.each(Data.slice(0, 100), (item) => {
						if (localStorage.isSet('notificationAcknowledged')
							// eslint-disable-next-line max-len
							&& localStorage.get('notificationAcknowledged.QuotationCase' + item.QuotationCaseID)) {
							return;
						}

						const policy = new PolicyForProlongation(options);
						policy.fromJS(item);

						policies.push(policy);
					});

					if (policies.length > 0) {
						const notification = page.notifications.create({
							template: {
								html: notificationTemplate(),
								data: {
									policies,
									openProlongationCalcClick: (id, link) => {
										onNotificationAcknowledged(id);
										location.href = link;
									},
								},
							},
						});

						notification.on('deleted', () => {
							_.each(policies, (policy) => {
								onNotificationAcknowledged(policy.QuotationCaseID());
							});
						});

						page.notifications.push(notification);
					}
				});
		})
		.done();
};
